import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useFinstrongStore, useGlobalCopyStore } from '../../../common'
import ProgressBar from '../ProgressBar'
import { getManageDebtRatioState, getPercentFromRatio } from '../../util/finstrongUtils'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { buildDynamicCopy } from '../../../core/utils/Localization'

const HaveManageableDebtProgressBar = () => {
  const { healthScore } = useFinstrongStore()
  const { finstrong: copy } = useGlobalCopyStore()

  const debtPercentage = getPercentFromRatio(healthScore.debt_to_income_ratio)

  const cardStatus = getManageDebtRatioState(debtPercentage)

  return (
    <ProgressBar
      bottomComponent={
        <Stack
          sx={{
            alignItems: 'flex-end',
            flexDirection: 'row',
            height: 24,
            justifyContent: 'space-between',
            mt: 2,
            position: 'relative',
          }}
        >
          {/* 30% tick mark and label positioned at 30% */}
          <Box
            sx={{
              left: '30%',
              position: 'absolute',
              transform: 'translateX(-50%)',
            }}
          >
            <Stack
              sx={{
                alignItems: 'center',
                flexDirection: 'column',
                height: 24,
                justifyContent: 'flex-end',
              }}
            >
              <Divider
                orientation="vertical"
                sx={{
                  borderWidth: 1,
                  height: 8,
                }}
              />
              <Text sx={{ color: 'text.primary' }} variant="caption">
                30%
              </Text>
            </Stack>
          </Box>
          {/* Debt percentage positioned at the right end */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: 24,
              justifyContent: 'center',
              marginLeft: 'auto',
            }}
          >
            <Text variant="body2">
              {healthScore.debt_to_income_ratio
                ? (buildDynamicCopy(
                    copy.key_indicators_borrow.have_manageable_debt_drawer
                      .have_manageable_debt_sticky_description,
                    debtPercentage,
                  ) as string)
                : '-'}
            </Text>
          </Box>
        </Stack>
      }
      label={
        copy.key_indicators_borrow.have_manageable_debt_drawer.have_manageable_debt_sticky_title
      }
      status={cardStatus}
      statusBarData={[
        {
          percentage: `${debtPercentage}%`,
        },
      ]}
      value={formatCurrency(healthScore.ninety_day_debt_spend, '0,0.00')}
    />
  )
}

export default observer(HaveManageableDebtProgressBar)
